<main class="d-flex flex-column h-100 bg-white">
  <ng-permit-single *ngIf="(store$ | async) as store"
                    [permits]="store.permits"
                    [selectedPermit]="store.selectedPermit"
                    (addPermit)="addPermitTab()"
                    (removePermit)="removePermitTab($event)">
  </ng-permit-single>
</main>
